import cs from "classnames";
import React from "react";


export type AppLayoutProps = {
    children: React.ReactNode
    className?: string | undefined
}
export const AppLayout = ({children, className}: AppLayoutProps) => {
    return <div className={cs("bg-gray-100 min-h-full p-4", className)}>
        <div className={cs("max-w-5xl mx-auto")}>
            {children}
        </div>
    </div>
}